let renderMode = false;

export function setRenderMode(active: boolean): void {
  renderMode = active;
}

export function isInRenderMode(): boolean {
  return renderMode;
}
